import { mapEnumToOptions } from '@abp/ng.core';

export enum D365TransactionQueueStatus {
  New = 1,
  Inserted = 2,
  JournalCreated = 3,
  Fetch = 4,
  Error = 5,
  All = 6,
  JournalCreatedDeleted = 7,
}

export const d365TransactionQueueStatusOptions = mapEnumToOptions(D365TransactionQueueStatus);
